// extracted by mini-css-extract-plugin
export default {"ConsentForm":"ConsentForm_ConsentForm__ShgLr"};